/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var JoveValidationState;

(function (JoveValidationState) {
  JoveValidationState["SUCCESS"] = "success";
  JoveValidationState["PENDING"] = "pending";
  JoveValidationState["FAIL"] = "fail";
})(JoveValidationState || (JoveValidationState = {}));